import { AbstractControl, UntypedFormGroup } from "@angular/forms";

export function isStandardFieldHidden(hiddenStandardFields: string[] | null | undefined, fieldKey: string): boolean {
	return !!hiddenStandardFields?.some(key => key?.toLowerCase() === fieldKey.toLowerCase());
}

export function disableHiddenStandardControls(form: UntypedFormGroup | undefined, hiddenStandardFields: string[] | null | undefined): void {
	if (!form || !hiddenStandardFields?.length) {
		return;
	}

	let hasHiddenControl = false;

	Object.entries(form.controls).forEach(([key, control]: [string, AbstractControl]) => {
		if (!isStandardFieldHidden(hiddenStandardFields, key)) {
			return;
		}

		hasHiddenControl = true;
		control.clearValidators();
		control.disable({ emitEvent: false });
		control.updateValueAndValidity({ emitEvent: false });
	});

	if (hasHiddenControl) {
		form.updateValueAndValidity({ emitEvent: false });
	}
}
